import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { PayloadService } from '../../services/payload.service';

@Component({
  selector: 'app-eventi',
  imports: [RouterLink],
  templateUrl: './eventi.component.html',
  styleUrl: './eventi.component.scss',
})
export class EventiComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);
  private document = inject(DOCUMENT);
  private payloadService = inject(PayloadService);

  eventi: any[] = [];

  ngOnInit(): void {
    this.setSeoMeta();

    this.payloadService.getEventi().subscribe((res: any) => {
      this.eventi = res.docs ?? [];
      this.setJsonLd();
    });
  }

  getSlugName(slug: string): string {
    return slug?.split('/').pop() ?? '';
  }

  showEndDate(evento: any): boolean {
    if (!evento.dataFine) return false;
    return new Date(evento.dataInizio).toDateString() !== new Date(evento.dataFine).toDateString();
  }

  getImageUrl(evento: any): string {
    if (evento.immagineCopertina?.url) {
      return evento.immagineCopertina.url;
    }
    return '';
  }

  private setSeoMeta(): void {
    this.title.setTitle('Eventi - Come Tralci');
    this.meta.updateTag({
      name: 'description',
      content: 'Scopri tutti gli eventi organizzati da Come Tralci: ritiri, campi, incontri e molto altro. Iscriviti e partecipa!',
    });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });

    this.meta.updateTag({ property: 'og:title', content: 'Eventi - Come Tralci' });
    this.meta.updateTag({
      property: 'og:description',
      content: 'Scopri tutti gli eventi organizzati da Come Tralci: ritiri, campi, incontri e molto altro.',
    });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:url', content: 'https://cometralci.com/eventi' });
    this.meta.updateTag({ property: 'og:site_name', content: 'Come Tralci' });
    this.meta.updateTag({ property: 'og:locale', content: 'it_IT' });

    this.updateCanonicalUrl('https://cometralci.com/eventi');
  }

  private setJsonLd(): void {
    const existingScript = this.document.querySelector('script#eventi-jsonld');
    if (existingScript) existingScript.remove();

    const itemListElements = this.eventi.map((evento, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `https://cometralci.com/eventi/${evento.slug}`,
      name: evento.titolo,
    }));

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Eventi Come Tralci',
      description: 'Lista degli eventi organizzati da Come Tralci',
      numberOfItems: this.eventi.length,
      itemListElement: itemListElements,
    };

    const script = this.document.createElement('script');
    script.id = 'eventi-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    this.document.head.appendChild(script);
  }

  private updateCanonicalUrl(url: string): void {
    let link = this.document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (link) {
      link.href = url;
    } else {
      link = this.document.createElement('link');
      link.rel = 'canonical';
      link.href = url;
      this.document.head.appendChild(link);
    }
  }
}
